export default __webpack_public_path__ + "static/media/stationsGasTankSide.0c035c24.jpg";